<template>
  <div>
    <v-dialog
      v-model="isVisible"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="450"
      persistent
      scrollable
    >
      <v-card v-if="editItem">
        <v-toolbar
          flat
          height="80"
          max-height="80"
        >
          <v-avatar color="primary">
            <v-icon dark>
              {{ $t('Marketing.Tag.Dialog.EditTag.Toolbar.Add.Icon') }}
            </v-icon>
          </v-avatar>

          <v-toolbar-title
            v-if="!editItem?.Id"
            class="pl-3"
          >
            <div class="body-3">
              {{ $t('Marketing.Tag.Dialog.EditTag.Toolbar.Add.Title') }}
            </div>

            <div class="text-caption">
              {{ $t('Marketing.Tag.Dialog.EditTag.Toolbar.Add.SubTitle') }}
            </div>
          </v-toolbar-title>

          <v-toolbar-title
            v-else
            class="pl-3"
          >
            <div class="body-3">
              {{ $t('Marketing.Tag.Dialog.EditTag.Toolbar.Edit.Title') }}
            </div>

            <div class="text-caption">
              {{ $t('Marketing.Tag.Dialog.EditTag.Toolbar.Edit.SubTitle') }}
            </div>
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            icon
            @click="onCancelButtonClick"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider />

        <v-card-text class="pa-3">
          <v-form
            ref="dataForm"
            v-model="formValid"
            @submit.prevent
          >
            <v-container
              class="pa-1"
              fluid
            >
              <v-row dense>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editItem.Name"
                        :counter="50"
                        :hint="$t('Marketing.Tag.Dialog.EditTag.Field.Name.Hint')"
                        :label="$t('Marketing.Tag.Dialog.EditTag.Field.Name.Label')"
                        :maxlength="50"
                        :prepend-icon="$t('Marketing.Tag.Dialog.EditTag.Field.Name.Icon')"
                        :rules="validationRules.dataForm.Name"
                        class="pr-2"
                        required
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />

          <v-btn
            class="light-blue--text text--darken-1"
            outlined
            @click="onCancelButtonClick"
          >
            {{ $t('Common.Button.Cancel').toLocaleUpperCase($i18n.locale) }}
          </v-btn>

          <v-btn
            :disabled="loading"
            :loading="loading"
            class="green white--text elevation-0"
            @click="onSaveButtonClick"
          >
            {{ $t('Common.Button.Save').toLocaleUpperCase($i18n.locale) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import AppData from '@/mixins/appdata'
import Auth from '@/mixins/auth'
import {clone, mergeDeep} from '@/lib/helper/helper'
import DialogVisible from '@/mixins/dialogVisible.js'

export default {
  name      : 'TagAddDialog',
  components: {},
  mixins    : [AppData, Auth, DialogVisible],
  props     : {
    tag: {
      type   : Object,
      default: undefined
    }
  },
  data() {
    return {
      formValid     : false,
      loading       : false,
      editItem      : null,
      defaultDataObj: {
        Id  : null,
        Name: ''
      },
      validationRules: {
        dataForm: {
          Name: [
            (v) => v && v.length >= 2 && v.length <= 50 || this.$t('Marketing.Tag.Dialog.EditTag.Field.Name.Error.Between')
          ]
        }
      }
    }
  },
  computed: {},
  watch   : {
    isVisible(newVal) {
      if (newVal) {
        this.initDialog()
      } else {
        this.destroyDialog()
      }
    }
  },
  created() {
    this.initDialog()
  },
  mounted() {
  },
  updated() {
  },
  beforeDestroy() {
    this.destroyDialog()
  },
  methods: {
    initDialog() {
      this.formValid = false
      this.loading = false
      this.editItem = clone(mergeDeep(this.defaultDataObj, this.tag || {}))
      this.$nextTick(() => {
        if (this.$refs.dataForm) this.$refs.dataForm.resetValidation()
      })

      this.initEvents()
    },
    destroyDialog() {
      this.editItem = null
      this.destroyEvents()
    },
    initEvents() {
      this.destroyEvents()
      this.$bus.$on(window.SocketCommand.Marketing.Tag.Save, this.onSaveResult)
    },
    destroyEvents() {
      this.$bus.$off(window.SocketCommand.Marketing.Tag.Save, this.onSaveResult)
    },

    onSaveButtonClick() {
      this.$refs.dataForm.validate()
      if (!this.formValid) return

      this.loading = true
      const saveObj = clone(this.editItem)
      window.callAS(window.SocketCommand.Marketing.Tag.Save, saveObj)
      if (this.$refs.dataForm) this.$refs.dataForm.resetValidation()
    },

    onSaveResult(result, payload) {
      if (result && result.status === 'success') {
        this.onCancelButtonClick()
      } else {
        this.$bus.$emit('app-show-notification', {
          body: result?.message || this.$t('Common.Error.Generic'),
          type: 'error',
          icon: 'warning'
        })
      }

      this.loading = false
      this.$emit('onSaveResult', result)
    },

    onCancelButtonClick() {
      if (this.$refs.dataForm) this.$refs.dataForm.resetValidation()
      this.closeDialog()
    }
  }
}
</script>

<style scoped>

</style>
